import React from 'react';
import PropTypes from 'prop-types';

function ColGroup({ list, containerWidth, paddingX }) {
  return (
    <colgroup>
      {list.map((width, index) => (
        <col
          span="1"
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          style={{
            width: `calc(${((+width + +paddingX) / containerWidth) * 100}%)`,
          }}
        />
      ))}
    </colgroup>
  );
}

ColGroup.propTypes = {
  list: PropTypes.arrayOf(PropTypes.number),
  containerWidth: PropTypes.number,
  paddingX: PropTypes.number,
};

ColGroup.defaultProps = {
  list: [],
  containerWidth: 786,
  paddingX: 24,
};

export default React.memo(ColGroup);
